import { render, staticRenderFns } from "./MultiplesClientes.vue?vue&type=template&id=0497a5a6&scoped=true"
import script from "./MultiplesClientes.vue?vue&type=script&lang=js"
export * from "./MultiplesClientes.vue?vue&type=script&lang=js"
import style0 from "./MultiplesClientes.vue?vue&type=style&index=0&id=0497a5a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0497a5a6",
  null
  
)

export default component.exports